import Survey from "components/request-document/components/Survey";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { STATUS_PROCESS } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { React, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice,
  submitSmartFormSlice,
  submitSmartO,
} from "redux/modules/visaForm";

export default function SurveyStep() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();

  const { personalId } = usePersonalDetail();
  const { smartserviceId } = useSmartService();
  const {
    addSmartFormState,
    submitSmartFormState,
    getSmartForm,
    draftId,
    smartform,
  } = useSmartForm();

  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;

  useEffect(() => {
    if (smartserviceId) {
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (!submitSmartFormState.isLoading) {
      if (submitSmartFormState.isSuccess) {
        hideLoading();
        dispatch(setSmartFormStep(SMART_T_STEP.SUMMARIZE));
      } else if (submitSmartFormState.isFailure) {
        hideLoading();
        alert(submitSmartFormState.error?.message);
        dispatch(submitSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    dispatch,
    hideLoading,
    submitSmartFormState.error?.message,
    submitSmartFormState.isFailure,
    submitSmartFormState.isLoading,
    submitSmartFormState.isSuccess,
  ]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        dispatch(addSmartFormSlice.actions.clearAsyncState());

        if (isDraftDocument) {
          dispatch(submitSmartO({ draftId }));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, draftId, hideLoading]);

  return <Survey isDraftDocument={isDraftDocument} />;
}
